import React from 'react';
import Box from '@mui/material/Box';
import KeyButton from './KeyButton';

interface KeyboardProps {
  onKeyPress: (key: string) => void;
  disabledKeys: string[]; // add this line
  className?:string;
}

const Keyboard: React.FC<KeyboardProps> = ({ onKeyPress, disabledKeys, className }) => { // add disabledKeys here
  const letters = [
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M', '<-'],
  ];

  return (
    <Box className={className} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2, width: '100%'}}>
      {letters.map((row, rowIndex) => (
        <Box key={rowIndex} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          {row.map((letter) => (
            <KeyButton
              key={letter}
              letter={letter}
              onClick={() => onKeyPress(letter)}
              disabled={disabledKeys.includes(letter)}
            />
          ))}
        </Box>
      ))}

      {/* <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap'}}>
        <KeyButton
          style={{ minWidth: '120px' }}
          key={'space'}
          letter={' '}
          onClick={() => onKeyPress(' ')}
        />
      </Box> */}
      <Box/>
    </Box>

  );
};

export default Keyboard;